import React, { useState } from "react";

import { Button, FormControl, InputGroup, Modal } from "react-bootstrap";
import { useController, UseControllerProps } from "react-hook-form";

import { useQuery } from "@tanstack/react-query";


// import { Error } from "@/_helpers/errorType.ts";
import { defaultTheme } from "@/assets/css/defaultTheme";
import search from "@/assets/svg/search.svg";
import Trash from "@/assets/svg/Trash";
import ColoredMarker from "@/common/components/ColoredMarker";
import { ErrorForm } from "@/common/components/form/ErrorForm.tsx";
import { LabelForm } from "@/common/components/form/LabelForm.tsx";
import Loader from "@/common/components/Loader.tsx";
import { getBuildings } from "@/modules/building/services";

import { IBuilding, IResponsePaginateServices } from "../../building/reducers";

type DwellingAssociateBuildingFormProps = UseControllerProps;

const DwellingAssociateBuildingForm = (
  props: DwellingAssociateBuildingFormProps,
) => {
  const [inputFilter, setInputFilter] = useState("");
  const { field, fieldState } = useController(props);
  const [showAssociateModal, setShowAssociateModal] = useState<boolean>(false);
  const [tempBuilding, setTempBuilding] = useState<IBuilding>();

  const { data, isLoading } = useQuery<IResponsePaginateServices, Error>(
    ["buildings", inputFilter],
    () =>
      getBuildings({
        filter: inputFilter,
        rows: 10,
        first: 0,
      }),
    {
      enabled: true,
      staleTime: Infinity,
    },
  );

  const handleClose = () => {
    setShowAssociateModal(false);
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    /*setActivePage(1);*/
    setInputFilter(e.target.value);
  };
  const validate = () => {
    field.onChange(tempBuilding);
    handleClose();
  };

  return (
    <>
      <div className={"w-100 form-input"}>
        <LabelForm label={"Immeuble associé"} />
        {field.value && field.value?.id ? (
          <div onClick={() => setShowAssociateModal(true)}>
            <ColoredMarker
              color="#641ABF"
              className="text-truncate text-wrap w-100"
            >
              Im.: {field.value.address.address}, {field.value.address.zip}{" "}
              {field.value.address.city}
              <Button
                className="ms-3 p-0 align-baseline"
                variant="none"
                onClick={(e) => {
                  e.stopPropagation();
                  field.onChange({
                    id: "",
                    address: {
                      address: "",
                      zip: "",
                      city: "",
                    },
                  });
                }}
              >
                <Trash color="red" />
              </Button>
            </ColoredMarker>
          </div>
        ) : (
          <div
            style={{
              backgroundColor: "rgb(250, 250, 250)",
            }}
            className={
              "d-flex align-items-center justify-content-center w-100 position-relative p-2"
            }
          >
            <Button
              className="d-flex align-items-center"
              /*position-absolute top-0 start-0*/
              variant="success"
              onClick={() => setShowAssociateModal(true)}
            >
              <span
                className="m-0 me-2"
                style={{ fontSize: "40px", lineHeight: "14px" }}
              >
                +
              </span>
              Associer à un immeuble existant
            </Button>
          </div>
        )}
        <ErrorForm error={fieldState.error} />
      </div>
      <Modal
        style={{
          zIndex: 9999,
          backgroundColor: "rgba(0,0,0,0.37)",
        }}
        show={showAssociateModal}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          closeButton
          style={{ borderBottom: "none", padding: "2rem 2rem 1rem" }}
        ></Modal.Header>
        <div style={{ padding: "0 2rem 2rem" }}>
          <p
            className="m-0 pb-0 fw-bolder text-center"
            style={{
              color: defaultTheme.palette.primary.dark,
              fontFamily: defaultTheme.typography.fontFamily,
            }}
          >
            Associer à un immeuble existant
          </p>
          <div className="d-flex flex-column justify-content-center">
            <InputGroup className="dataGridSearchBar my-3">
              <InputGroup.Text>
                <img src={search} alt="Search Icon" />
              </InputGroup.Text>
              <FormControl
                style={{ height: "auto", padding: "0" }}
                className="dataGridSearchBarInput d-none d-lg-inline"
                placeholder="Rechercher"
                defaultValue={inputFilter}
                onChange={handleChangeInput}
              />
              <FormControl
                style={{ height: "auto" }}
                className="dataGridSearchBarInput d-lg-none"
                placeholder="Rechercher..."
                defaultValue={inputFilter}
                onChange={handleChangeInput}
              />
            </InputGroup>
            {tempBuilding !== undefined && (
              <>
                <ColoredMarker
                  color="#641ABF"
                  className="text-truncate text-wrap"
                >
                  Im.: {tempBuilding.address.address},{" "}
                  {tempBuilding.address.zip} {tempBuilding.address.city}
                  <Button
                    className="ms-3 p-0 align-baseline"
                    variant="none"
                    onClick={() => setTempBuilding(undefined)}
                  >
                    <Trash color="red" />
                  </Button>
                </ColoredMarker>
                <hr className="text-muted" />
              </>
            )}
            <div className="d-flex flex-column justify-content-start overflow-auto mx-2">
              {data && data.buildings.length > 0 ? (
                <>
                  {data.buildings.map((building) => {
                    if (
                      tempBuilding === undefined ||
                      building.id !== tempBuilding.id
                    ) {
                      return (
                        <Button
                          variant="none"
                          className="mb-1 p-0 text-start text-truncate"
                          key={building.id}
                          onClick={() => setTempBuilding(building)}
                        >
                          <small
                            className="text-muted mt-0 pt-0 fw-bolder"
                            style={{
                              fontFamily: defaultTheme.typography.fontFamily,
                            }}
                          >
                            Im.: {building.address.address},{" "}
                            {building.address.zip} {building.address.city}
                          </small>
                        </Button>
                      );
                    }
                    return null;
                  })}
                </>
              ) : isLoading ? (
                <Loader />
              ) : (
                <>
                  <p className="p-no-property mt-3 ms-2">
                    Aucun immeuble disponible.
                  </p>
                </>
              )}
            </div>
            <div className="mt-3 d-flex flex-row justify-content-center w-100 mt-4 mb-2">
              <Button
                variant="success"
                onClick={() => validate()}
                style={{ width: "100px" }}
              >
                Valider
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default DwellingAssociateBuildingForm;
